import React from 'react'
import { IconTag } from '@tabler/icons-react'

import { Card } from '@/components/cards/Card'
import { Pill } from '@/components/pills/Pill'

import { TagList } from './TagList'

export const UncategorizedTagsCard = ({ column, tags, deleteTag }) => {
  return (
    <Card compact className="no-margin" data-testid="uncategorized-card">
      <header className="module-card-section-header">
        <IconTag className="icon-svg" />
        <h3>Uncategorized</h3>
        <Pill xs>{tags.length}</Pill>
      </header>
      <TagList column={column} tags={tags} deleteTag={deleteTag} />
    </Card>
  )
}
